// extracted by mini-css-extract-plugin
export default {"main":"styles_main__zB1n1","main__margin":"styles_main__margin__A0eo1"};